import styled from 'styled-components'

export const ScrollablePage = styled.div`
    background-color: ${(props) => props.theme.colors.background.page};
`
